import { useState } from "react";
import { motion } from "framer-motion";

const SERVICES = [
    {
        num: "01",
        title: "Fotografia Sportiva",
        desc: "Match, allenamenti e ritratti atletici. Copertura completa con teleobiettivi e consegna rapida per social e stampa.",
        image: "https://images.unsplash.com/photo-1608245449230-4ac19066d2d0?q=85&w=1200",
    },
    {
        num: "02",
        title: "Ritratti & Editoriali",
        desc: "Direzione creativa, styling e luce. Servizi in studio o in esterna per brand, magazine e talent.",
        image: "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?q=85&w=1200",
    },
    {
        num: "03",
        title: "Video & Montaggio",
        desc: "Riprese cinematiche, storytelling e post-produzione. Color grading, sound design e delivery multi-formato.",
        image: "https://images.unsplash.com/photo-1580707221190-bd94d9087b7f?q=85&w=1200",
    },
    {
        num: "04",
        title: "Riprese con Drone",
        desc: "Aeree autorizzate ENAC. Paesaggi, immobili, eventi e cantieri con droni 4K/6K stabilizzati.",
        image: "https://images.unsplash.com/photo-1665314673834-635d0fedab32?q=85&w=1200",
    },
    {
        num: "05",
        title: "Eventi & Matrimoni",
        desc: "Cerimonie, party, convention e concerti. Fotografo + operatore video + drone in un'unica regia coordinata.",
        image: "https://images.unsplash.com/photo-1606216836549-f60d04e4a20b?q=85&w=1200",
    },
    {
        num: "06",
        title: "Grafica & Brand",
        desc: "Copertine, key visual, poster e format social. Identità visiva coerente costruita insieme al contenuto.",
        image: "https://images.unsplash.com/photo-1625690303837-654c9666d2d0?q=85&w=1200",
    },
];

export default function Services() {
    const [hoverImg, setHoverImg] = useState(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });

    const handleMove = (e) => {
        setPos({ x: e.clientX, y: e.clientY });
    };

    return (
        <section
            id="services"
            className="relative bg-ink-950 py-20 md:py-40 px-5 md:px-10 border-t border-white/10"
            onMouseMove={handleMove}
            data-testid="services-section"
        >
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                {/* Sticky left */}
                <div className="md:col-span-4 md:sticky md:top-32 self-start">
                    <div className="overline mb-6">
                        <span className="text-flash">■</span>&nbsp;&nbsp;02 — Manifesto
                    </div>
                    <h2
                        className="font-display uppercase text-bone-50 leading-[0.85] tracking-[-0.03em]"
                        style={{ fontSize: "clamp(2.5rem, 6vw, 6rem)" }}
                        data-testid="services-heading"
                    >
                        Servizi<span className="text-flash">.</span>
                    </h2>
                    <p className="mt-6 max-w-md text-bone-400 font-light text-base md:text-lg">
                        Un flusso <span className="font-serif-i text-bone-50">end-to-end</span>: dalla concezione dell'idea
                        al file consegnato, tutto sotto lo stesso occhio.
                    </p>
                </div>

                {/* List */}
                <ul className="md:col-span-8 divide-y divide-white/10 border-y border-white/10" data-testid="services-list">
                    {SERVICES.map((s) => (
                        <li
                            key={s.num}
                            className="group py-6 md:py-10 flex items-baseline gap-4 md:gap-10 relative md:cursor-none"
                            onMouseEnter={() => setHoverImg(s.image)}
                            onMouseLeave={() => setHoverImg(null)}
                            data-testid={`service-item-${s.num}`}
                        >
                            <span className="font-mono text-[10px] md:text-[11px] tracking-[0.25em] uppercase text-bone-600 group-hover:text-flash transition-colors duration-500 w-6 md:w-10 flex-shrink-0">
                                {s.num}
                            </span>
                            <div className="flex-1 min-w-0">
                                <h3
                                    className="font-display uppercase text-bone-50 leading-none tracking-[-0.02em] transition-transform duration-500 md:group-hover:translate-x-2"
                                    style={{ fontSize: "clamp(1.35rem, 3.6vw, 3.6rem)" }}
                                >
                                    {s.title}
                                </h3>
                                <p className="mt-3 max-w-xl text-bone-400 font-light text-sm md:text-base opacity-80 md:opacity-70 md:group-hover:opacity-100 transition-opacity duration-500">
                                    {s.desc}
                                </p>
                            </div>
                            <span className="hidden md:block font-mono text-[11px] tracking-[0.25em] uppercase text-bone-600 group-hover:text-bone-50 transition-colors duration-500">
                                Info ↗
                            </span>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Floating hover image */}
            {hoverImg && (
                <motion.img
                    key={hoverImg}
                    src={hoverImg}
                    alt=""
                    initial={{ opacity: 0, scale: 0.92 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4, ease: [0.19, 1, 0.22, 1] }}
                    className="hidden md:block fixed pointer-events-none z-40 w-[320px] h-[420px] object-cover ring-1 ring-white/10"
                    style={{ left: pos.x + 40, top: pos.y - 210 }}
                    data-testid="services-hover-image"
                />
            )}
        </section>
    );
}
